/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EEcmPanelStatus, ESidePanelContent } from '../../models';
import { IEcmPanelState } from '../state';
import { getSidePanelContent } from './side-panel.selectors';

export const getEcmPanelState = createFeatureSelector<IEcmPanelState>('ecmPanel');

export const getEcmPanelVehicleName = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.vehicleName);

export const getEcmPanelVehicleId = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.vehicleId);

export const getEcmPanelPlotType = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.plotType);

export const getEcmPanelDiagnostics = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.diagnostics);

export const getEcmPanelStatus = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.status);

export const getIsEcmPanelOpen = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.status === EEcmPanelStatus.Open);

export const getEcmPanelDiagnosticsLoading = createSelector(
  getEcmPanelState,
  (state: IEcmPanelState) => state.status === EEcmPanelStatus.Loading
);

export const getEcmPanelDiagnosticsErrors = createSelector(getEcmPanelState, (state: IEcmPanelState) => state.diagnosticsErrors);

/**
 * True only when the ECM diagnostics panel is BOTH open AND the currently displayed side panel.
 * Used to grey out the balloon "More Details" link: it must be disabled only while the ECM panel is the
 * active side panel, not when another panel (device health, geofence, ...) is shown over a still-open ECM slice.
 */
export const getIsEcmPanelActive = createSelector(
  getIsEcmPanelOpen,
  getSidePanelContent,
  (isOpen: boolean, content: ESidePanelContent): boolean => isOpen && content === ESidePanelContent.Ecm
);
